import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { db } from '../../Services/firebase';
import HeaderStyleTwo from '../Shared/HeaderStyleTwo';
import SearchPopup from '../Shared/SearchPopup';
import MobileNav from '../Shared/MobileNav';
import Footer from '../Shared/Footer';
import ScrollToTop from '../Shared/ScrollToTop';
import PageHeader from '../Shared/PageHeader';
import axios from 'axios';
import MaskedInput from 'react-text-mask';
import NumberFormat from 'react-number-format';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import PaymentIcon from '@material-ui/icons/Payment';
import Select from '@material-ui/core/Select';
import { Button, ButtonGroup, MenuItem, withStyles } from '@material-ui/core';
import SecurityIcon from '@material-ui/icons/Security';
import Alert from '@material-ui/lab/Alert/Alert';
import MoneyIcon from '@material-ui/icons/Money';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import MyLocation from '@material-ui/icons/MyLocation';
import Streetview from '@material-ui/icons/Streetview';
import EditLocationIcon from '@material-ui/icons/EditLocation';
import Room from '@material-ui/icons/Room';
import LocationOn from '@material-ui/icons/LocationOn';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import emailMask from 'text-mask-addons/dist/emailMask';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatAlignJustifyIcon from '@material-ui/icons/FormatAlignJustify';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, generatePath, useHistory, Link } from 'react-router-dom';
import { ROUTES } from '../../Constants/index';
import { signup, signInAnonymously } from '../../Services/user/user.api';
import { FETCH_STATUSES } from '../../Services/base/types';
import { AppState } from '../../Services';
import Cryptr from 'cryptr';
import { v4 as uuidv4 } from 'uuid';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { CountryRegionData } from 'react-country-region-selector';
import Autocomplete from '@material-ui/lab/Autocomplete';

import CircularProgress from '@material-ui/core/CircularProgress';
const cryptr = new Cryptr(
  'AIzaSyAN7RRyq6XFpzuIwLolmRjG2GHT4HpPxcE-1:394913796951:web:6e1734d36d7324d593e412'
);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },

    textField: {
      marginTop: theme.spacing(2),
      minWidth: 120,
    },
    formControl: {
      marginTop: theme.spacing(2),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);
const StyledToggleButton = withStyles({
  root: {
    fontFamily: 'Arial',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '15px 15px',
    textTransform: 'none',
    display: 'block',
    width: '100%',
    '&$selected': {
      backgroundColor: '#ff6d12',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#ff6d12',
        color: '#FFFFFF',
      },
    },
  },
  selected: {},
})(ToggleButton);

interface TextMaskCustomProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}
function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
function TextMaskCustom(props: TextMaskCustomProps) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={emailMask}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

interface NumberFormatCustomProps {
  //@ts-ignore
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}
function CardNumberFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
      format='#### #### #### ####'
      mask='_'
    />
  );
}
function SecurityCodeFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
      format='####'
    />
  );
}

function DonationFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix='$'
    />
  );
}

const ValidationTextField = withStyles({
  root: {
    '& input:valid + fieldset': {
      borderColor: 'green',
      borderWidth: 2,
    },
    '& input:invalid + fieldset': {
      borderColor: 'red',
      borderWidth: 2,
    },
    '& input:valid:focus + fieldset': {
      borderLeftWidth: 6,
      padding: '4px !important', // override inline-style
    },
  },
})(TextField);
interface State {
  cardNumber: string;
  securityCode: string;
  donation: string;
  firstName: string;
  lastName: string;
  country: string;
  region: string;
  address: string;
  address2: string;
  city: string;
  postalCode: string;
  wellBeneficiaryName: string;
  email: string;
  type: string;
  donationType: string;
  programType: string;
  expirationMonth: string;
  expirationYear: string;
  selectedDonation: string;
  isProcessingFeeAdded: boolean;
  makeDonationAnonymous: boolean;
  uid: string;
  comment: string;
}
const Donate = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const payload: any = location.state;
  const CHARACTER_LIMIT_DONATION = 8;
  const [programData, setProgramTypeData] = useState<any>({});
  const [invoiceAmount, setInvoiceAmount] = React.useState('');
  const [paymentProcessingFee, setpaymentProcessingFee] = React.useState('');
  const [donationAmount, setDonationAmount] = React.useState('');
  const [values, setValues] = React.useState<State>({
    cardNumber: '',
    securityCode: '',
    donation: '',
    firstName: '',
    lastName: '',
    country: 'United States',
    region: '',
    address: '',
    address2: '',
    city: '',
    postalCode: '',
    wellBeneficiaryName: '',
    email: '',
    type: 'once',
    donationType: '',
    programType: '',
    selectedDonation: '100',
    expirationMonth: '',
    expirationYear: '',
    makeDonationAnonymous: false,
    isProcessingFeeAdded: true,
    uid: '',
    comment: '',
  });

  useEffect(() => {
    //   setTimeout(function(){
    //     runJQueryScripts();
    //     // alert("After 5 seconds!");

    // }, 1000);
    runJQueryScripts();
    window.scrollTo(0, 0);
    setProgramTypeData(payload);
    //console.log("payload", payload)

    if (
      payload &&
      payload?.programType !== undefined &&
      payload?.programType !== ''
    ) {
      setValues({
        ...values,
        ['programType']: payload.programType as string,
      });
    } else {
      setValues({
        ...values,
        ['programType']: '' as string,
      });
    }
    calcFee(Number(values.selectedDonation));
    // setInvoiceAmount(calculatedFee.total);
  }, []);

  const runJQueryScripts = () => {
    let tag: any;
    let loadScript = function (src: string) {
      tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      document.getElementsByTagName('body')[0].appendChild(tag);
    };
    loadScript('../assets/js/jquery.js');
    loadScript('../assets/js/popper.min.js');
    loadScript('../assets/js/jquery-ui.js');
    loadScript('../assets/js/jquery.fancybox.js');
    loadScript('../assets/js/owl.js');
    loadScript('../assets/js/appear.js');
    loadScript('../assets/js/wow.js');
    loadScript('../assets/js/lazyload.js');
    loadScript('../assets/js/scrollbar.js');
    loadScript('../assets/js/script.js');
    return () => {
      document.getElementsByTagName('body')[0].removeChild(tag);
    };
  };

  const [isShowDonationError, setIsShowDonationError] = React.useState(false);
  const [isShowCardNumberError, setIsShowCardNumberError] =
    React.useState(false);
  const CHARACTER_LIMIT_CARD_NUMBER = 27;
  const [isShowSecurityCodeError, setIsShowSecurityCodeError] =
    React.useState(false);
  const [btnDisabled, setBtnDisabled] = React.useState(false);
  const [isShowFirstNameError, setIsShowFirstNameError] = React.useState(false);
  const CHARACTER_LIMIT_FIRST_NAME = 25;
  const [isShowLastNameError, setIsShowLastNameError] = React.useState(false);
  const CHARACTER_LIMIT_LAST_NAME = 25;
  const [isShowEmailError, setIsShowEmailError] = React.useState(false);
  const CHARACTER_LIMIT_EMAIL_NAME = 50;
  const CHARACTER_LIMIT_COMMENT = 150;
  const CHARACTER_LIMIT_ZIP = 5;
  const [isShowTypeError, setIsShowTypeError] = React.useState(false);
  const [isShowPostalCodeError, setIsShowPostalCodeError] =
    React.useState(false);
  const [isShowCityError, setIsShowCityError] = React.useState(false);
  const [isShowAddressError, setIsShowAddressError] = React.useState(false);
  const [isShowWellBeneficiaryNameError, setIsShowWellBeneficiaryNameError] =
    React.useState(false);
  const [country, setCountry] = React.useState([
    'United States',
    'US',
    'Alabama~AL|Alaska~AK|American Samoa~AS|Arizona~AZ|Arkansas~AR|California~CA|Colorado~CO|Connecticut~CT|Delaware~DE|District of Columbia~DC|Micronesia~FM|Florida~FL|Georgia~GA|Guam~GU|Hawaii~HI|Idaho~ID|Illinois~IL|Indiana~IN|Iowa~IA|Kansas~KS|Kentucky~KY|Louisiana~LA|Maine~ME|Marshall Islands~MH|Maryland~MD|Massachusetts~MA|Michigan~MI|Minnesota~MN|Mississippi~MS|Missouri~MO|Montana~MT|Nebraska~NE|Nevada~NV|New Hampshire~NH|New Jersey~NJ|New Mexico~NM|New York~NY|North Carolina~NC|North Dakota~ND|Northern Mariana Islands~MP|Ohio~OH|Oklahoma~OK|Oregon~OR|Palau~PW|Pennsylvania~PA|Puerto Rico~PR|Rhode Island~RI|South Carolina~SC|South Dakota~SD|Tennessee~TN|Texas~TX|Utah~UT|Vermont~VT|Virgin Islands~VI|Virginia~VA|Washington~WA|West Virginia~WV|Wisconsin~WI|Wyoming~WY|Armed Forces Americas~AA|Armed Forces Europe, Canada, Africa and Middle East~AE|Armed Forces Pacific~AP',
  ]);
  const [region, setRegion] = React.useState(['']);
  const [isShowRegionError, setIsShowRegionError] = React.useState(false);
  const [isShowCountryError, setIsShowCountryError] = React.useState(false);
  const [isShowExpirationMonthError, setIsShowExpirationMonthError] =
    React.useState(false);
  const [isShowProgramTypeError, setIsShowProgramTypeError] =
    React.useState(false);
  const [isShowDonationTypeError, setIsShowDonationTypeError] =
    React.useState(false);
  const [isShowExpirationYearError, setIsShowExpirationYearError] =
    React.useState(false);
  const [isDonationFocus, setIsDonationFocus] = React.useState(false);
  let textInputDonation = React.createRef();

  const signInStatus = useSelector(
    (state: AppState) => state.user.status || null
  );
  // eslint-disable-next-line no-restricted-globals
  const isDirty = signInStatus === FETCH_STATUSES.LOADING;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.checked,
    });
  };

  const handleIsProcessingFeeAddedChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValues({
      ...values,
      [event.target.name]: event.target.checked,
    });

    if (event.target.checked === false) {
      setInvoiceAmount(donationAmount);
    } else {
      calcFee(Number(donationAmount));
      //setInvoiceAmount(donationAmount)
    }
  };

  const calcFee = (amount: number) => {
    let total = (amount + parseFloat('0.3')) / (1 - parseFloat('2.9') / 100);
    let fee = total - amount;
    setInvoiceAmount(total.toFixed(2));
    setpaymentProcessingFee(fee.toFixed(2));
    setDonationAmount(amount.toFixed(2));
  };

  const handleChangeCardNumber = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsShowCardNumberError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
    // event.target.setAttribute('autocomplete', 'off');
  };

  const handleChangeSecurityCode = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsShowSecurityCodeError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
    // event.target.setAttribute('autocomplete', 'off');
  };

  const handleChangeDonation = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowDonationError(false);
    calcFee(Number(event.target.value));
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeWellBeneficiaryName = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsShowWellBeneficiaryNameError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeFirstName = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setShowMessageSuccess(false);
    setIsShowFirstNameError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeLastName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowLastNameError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const getRegions = () => {
    // if (!country) {
    //   return '';
    // }
    // const countryRegionData = [];
    let countryRegionData = [''];
    CountryRegionData.forEach(element => {
      if (element[0] === values?.country) {
        //console.log("getRegions.CountryRegionData", element);
        countryRegionData = element;
      }
    });
    // console.log("getRegions.countryRegionData--->", countryRegionData[0]);

    return countryRegionData[2].split('|').map(regionPair => {
      let [regionName, regionShortCode = null] = regionPair.split('~');
      return regionName;
    });
  };

  const handleChangeAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowAddressError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeCity = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowCityError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangePostalCode = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsShowPostalCodeError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeAddress2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeComment = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowEmailError(false);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeType = (
    event: React.MouseEvent<HTMLElement>,
    type: string
  ) => {
    setIsShowTypeError(false);
    setValues({
      ...values,
      ['type']: type,
    });
  };

  const handleChangeSelectedDonation = (
    event: React.MouseEvent<HTMLElement>,
    selectedDonation: string
  ) => {
    setIsShowTypeError(false);
    if (selectedDonation !== 'Other') {
      calcFee(Number(selectedDonation));
    }
    setValues({
      ...values,
      ['selectedDonation']: selectedDonation,
    });
  };

  const handleChangeProgramType = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setIsShowProgramTypeError(false);
    setValues({
      ...values,
      ['programType']: event.target.value as string,
    });
  };
  const handleChangeDonationType = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setIsShowDonationTypeError(false);
    setValues({
      ...values,
      ['donationType']: event.target.value as string,
    });
  };

  const handleChangeSelectedDonationAndDonation = () => {
    setValues({
      ...values,
      ['selectedDonation']: 'Other',
    });
    setValues({
      ...values,
      ['donation']: '589',
    });
  };

  const handleChangeExpirationMonth = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setIsShowExpirationMonthError(false);
    setValues({
      ...values,
      ['expirationMonth']: event.target.value as string,
    });
  };

  const handleChangeCountry = (val: any) => {
    setIsShowCountryError(false);
    setValues({
      ...values,
      ['country']: val.target.value as string,
    });
  };
  const handleChangeRegion = (val: any) => {
    setIsShowRegionError(false);
    setValues({
      ...values,
      ['region']: val.target.value as string,
    });
  };

  const handleChangeExpirationYear = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setIsShowExpirationYearError(false);
    setValues({
      ...values,
      ['expirationYear']: event.target.value as string,
    });
  };
  const [showLoader, setShowLoader] = React.useState(false);
  const [showMessageSuccess, setShowMessageSuccess] = React.useState(false);
  const [showMessageError, setShowMessageError] = React.useState(false);
  const [messageSuccess, setMessageSuccess] = React.useState('');
  const [messageError, setMessageError] = React.useState('');
  const donateNow = async () => {
    try {
      let amount = 0;
      if (values.donation !== '') {
        amount = Number(values.donation);
        calcFee(amount);
      } else if (values.selectedDonation !== '') {
        amount = Number(values.selectedDonation);
        calcFee(amount);
      }

      const signInData = await signInAnonymously(
        values.firstName,
        values.lastName,
        values.email && values.email !== undefined
          ? values.email
          : 'dev.sadqajariya@gmail.com'
      );

      if (signInData && signInData.uid !== undefined && signInData.uid !== '') {
        setValues({
          ...values,
          ['uid']: signInData.uid,
        });
        const today = new Date();
        const todaydd = String(today.getDate()).padStart(2, '0');
        const todaymm = String(today.getMonth() + 1).padStart(2, '0');
        const todayyyyy = today.getFullYear();
        const lastFour = values.cardNumber.substr(values.cardNumber.length - 4);
        let uuid = uuidv4();
        let id = uuid + '-' + lastFour;
        let cardNumberEnc = cryptr.encrypt(values.cardNumber);
        let securityCodeEnc = cryptr.encrypt(values.securityCode);
        const data = {
          cardNumber: cardNumberEnc,
          securityCode: securityCodeEnc,
          donation: values.donation,
          invoiceAmount: parseFloat(Number(invoiceAmount).toFixed(2)),
          isProcessingFeeAdded: values.isProcessingFeeAdded,
          paymentProcessingFee: paymentProcessingFee,
          donationAmount: donationAmount,
          firstName: values.firstName,
          lastName: values.lastName,
          country: values.country,
          region: values.region,
          address: values.address,
          address2: values.address2,
          city: values.city,
          postalCode: values.postalCode,
          email: values.email,
          type: values.type,
          donationType: values.donationType,
          programType: values.programType,
          wellBeneficiaryName: values.wellBeneficiaryName,
          selectedDonation: values.selectedDonation,
          expirationMonth: values.expirationMonth,
          expirationYear: values.expirationYear,
          makeDonationAnonymous: values.makeDonationAnonymous,
          uid: signInData.uid,
          lastFour: '***' + lastFour,
          id: id,
          created: new Date().getTime(),
          paymentDate: new Date(
            todayyyyy + '-' + todaymm + '-' + todaydd
          ).getTime(),
          status: 'scheduled',
          isPaid: false,
          comment: values.comment,
        };
        setValues({
          cardNumber: '',
          securityCode: '',
          donation: values.donation,
          firstName: values.firstName,
          lastName: values.lastName,
          country: values.country,
          region: values.region,
          address: values.address,
          address2: values.address2,
          city: values.city,
          postalCode: values.postalCode,
          wellBeneficiaryName: values.wellBeneficiaryName,
          email: values.email,
          type: 'once',
          donationType: values.donationType,
          programType: values.programType,
          selectedDonation: values.selectedDonation,
          expirationMonth: values.expirationMonth,
          expirationYear: values.expirationYear,
          isProcessingFeeAdded: values.isProcessingFeeAdded,
          makeDonationAnonymous: values.makeDonationAnonymous,
          uid: values.uid,
          comment: values.comment,
        });
        // console.log("data--->", data);
        // const getInvolvedDonate =
        //   "http://localhost:5000/dev-sadqajariya/us-central1/getInvolvedApi/donate";

        const getInvolvedDonate =
          'https://us-central1-dev-sadqajariya.cloudfunctions.net/getInvolvedApi/donate';
        const headers = {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Max-Age': '0',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Authorization',
        };
        const donateResponce = await axios
          .post(getInvolvedDonate, data, {
            headers: headers,
          })
          .then(function (response) {
            setShowLoader(false);
            if (response.data.ERROR) {
              setBtnDisabled(false);
              setShowMessageSuccess(false);
              setMessageError(response.data.ERROR.raw.message);
              setShowMessageError(true);
              // history.push("/");
            } else if (response.data.data === 'Success') {
              history.push('/thanks');
              setValues({
                cardNumber: '',
                securityCode: '',
                donation: '',
                firstName: '',
                lastName: '',
                country: '',
                region: '',
                address: '',
                address2: '',
                city: '',
                postalCode: '',
                wellBeneficiaryName: '',
                email: '',
                type: 'once',
                donationType: '',
                programType: '',
                selectedDonation: '100',
                expirationMonth: '',
                expirationYear: '',
                isProcessingFeeAdded: true,
                makeDonationAnonymous: false,
                uid: '',
                comment: '',
              });
              setShowMessageSuccess(true);
              setShowMessageError(false);
              setBtnDisabled(false);
              calcFee(Number(values.selectedDonation));
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      }
    } catch (error) {
      // console.log("error--->", error);
    }
  };

  return (
    <>
      <HeaderStyleTwo />

      <div className='ulockd-inner-page'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='ulockd-icd-layer'>
                <ul className='list-inline ulockd-icd-sub-menu'>
                  <li>
                    <a style={{ color: '#25283a' }} href='/'>
                      {' '}
                      Home{' '}
                    </a>
                  </li>
                  <li>
                    <a style={{ color: '#25283a' }} href='#'>
                      <b> / </b>
                    </a>
                  </li>
                  <li>
                    {' '}
                    <a href='/get-involved'>Donate</a>{' '}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section
        className='donate-section'
        style={{
          borderTop: '1px solid rgb(234, 229, 227)',
          padding: '50px 0px 0px',
        }}
      >
        <div className='top-rotten-curve'></div>
        <div className='auto-container'>
          <div className='tabs-box'>
            <div className='row clearfix'>
              <div className='col-lg-12 col-md-12 col-sm-12'>
                <h2>
                  Your help turns into smiles.
                  {/* <br /> In about $20 you can feed a family of 5 for a month. */}
                </h2>
              </div>
            </div>
            <div className='row clearfix'>
              <div className='content-side col-lg-8 col-md-12 col-sm-12'>
                <div className='inner'>
                  {/* <form autoComplete="off"> */}

                  <div className='contact-form'>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <FormControl
                          variant='outlined'
                          className={classes.formControl}
                          style={{ width: '100%' }}
                        >
                          <InputLabel id='demo-simple-select-outlined-label'>
                            Select Program
                          </InputLabel>
                          <Select
                            labelId='demo-simple-select-outlined-label'
                            id='demo-simple-select-outlined'
                            required
                            autoComplete='none'
                            value={values?.programType}
                            onChange={handleChangeProgramType}
                            label='Select Program'
                            name='programType'
                          >
                            {/* <MenuItem value={"relief-for-flood-victims-in-pakistan"} style={{ zIndex: 999999999 }}>Relief for Flood Victims in Pakistan</MenuItem> */}
                            <MenuItem
                              value={
                                'monthly-grocery-for-widows-and-senior-citizen'
                              }
                              style={{ zIndex: 999999999 }}
                            >
                              Monthly Grocery for Widows & Senior Citizen
                            </MenuItem>
                            <MenuItem
                              value={'apna-rozgar'}
                              style={{ zIndex: 999999999 }}
                            >
                              Apna Rozgar (Small Business Setups)
                            </MenuItem>
                            <MenuItem
                              value={'medical-support'}
                              style={{ zIndex: 999999999 }}
                            >
                              Free Medical Support
                            </MenuItem>
                            <MenuItem
                              value={'basic-schools'}
                              style={{ zIndex: 999999999 }}
                            >
                              Free Education for Child (Basic Schools)
                            </MenuItem>
                            <MenuItem
                              value={'sasta-rashan-program'}
                              style={{ zIndex: 999999999 }}
                            >
                              Sasta Rashan Program{' '}
                            </MenuItem>
                            <MenuItem
                              value={'water-hand-pumps'}
                              style={{ zIndex: 999999999 }}
                            >
                              Clean Water Program (Water Hand Pumps)
                            </MenuItem>
                            <MenuItem
                              value={'sadqa-e-jariya-welfare-mart'}
                              style={{ zIndex: 999999999 }}
                            >
                              Sadqa-E-Jariya Welfare Mart
                            </MenuItem>
                            <MenuItem
                              value={'free-technical-training-center'}
                              style={{ zIndex: 999999999 }}
                            >
                              Technical Training Center Initiative
                            </MenuItem>
                            <MenuItem
                              value={'darul-akhlaq'}
                              style={{ zIndex: 999999999 }}
                            >
                              Darul Akhlaq Initiative
                            </MenuItem>
                          </Select>
                        </FormControl>
                        {isShowProgramTypeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Program Type cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-xl-12'>
                        <ToggleButtonGroup
                          value={values.selectedDonation}
                          exclusive
                          onChange={handleChangeSelectedDonation}
                          style={{ paddingTop: 15 }}
                        >
                          <StyledToggleButton value='300'>
                            $300
                          </StyledToggleButton>
                          <StyledToggleButton value='200'>
                            $200
                          </StyledToggleButton>
                          <StyledToggleButton value='100'>
                            $100
                          </StyledToggleButton>
                          {/* <StyledToggleButton value="50">
                          $50
                        </StyledToggleButton> */}
                          <StyledToggleButton value='Other'>
                            Other
                          </StyledToggleButton>
                        </ToggleButtonGroup>
                        {isShowTypeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Donation cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    {values.selectedDonation === 'Other' ? (
                      <>
                        <div className='row'>
                          <div className='col-xl-12'>
                            <TextField
                              label='Enter your Donation'
                              className={classes.textField}
                              value={values.donation}
                              autoComplete='none'
                              onChange={handleChangeDonation}
                              name='donation'
                              required
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position='start'>
                                    <MoneyIcon />
                                  </InputAdornment>
                                ),
                                inputComponent: DonationFormatCustom as any,
                              }}
                              inputProps={{
                                maxLength: CHARACTER_LIMIT_DONATION,
                              }}
                              variant='outlined'
                              style={{ width: '100%' }}
                            />
                            {isShowDonationError === true ? (
                              <div style={{ paddingTop: 5 }}>
                                <Alert severity='error'>
                                  Donation cannot be empty
                                </Alert>
                              </div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div> </div>
                    )}
                    <div className='row'>
                      <div className='col-xl-12'>
                        <ToggleButtonGroup
                          value={values.type}
                          exclusive
                          onChange={handleChangeType}
                          style={{ paddingTop: 15 }}
                        >
                          <StyledToggleButton value='once'>
                            DONATE ONCE
                          </StyledToggleButton>
                          <StyledToggleButton value='monthly'>
                            DONATE MONTHLY
                          </StyledToggleButton>
                        </ToggleButtonGroup>
                        {isShowTypeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>Type cannot be empty</Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-xl-12'>
                        <FormControl
                          variant='outlined'
                          className={classes.formControl}
                          style={{ width: '100%' }}
                        >
                          <InputLabel id='demo-simple-select-outlined-label'>
                            Select Donation Type
                          </InputLabel>
                          <Select
                            labelId='demo-simple-select-outlined-label'
                            id='demo-simple-select-outlined'
                            required
                            autoComplete='none'
                            value={values?.donationType}
                            onChange={handleChangeDonationType}
                            label='Select Donation Type'
                            name='donationType'
                          >
                            <MenuItem
                              value={'sadaqah'}
                              style={{ zIndex: 999999999 }}
                            >
                              Sadaqah
                            </MenuItem>
                            <MenuItem
                              value={'zakat'}
                              style={{ zIndex: 999999999 }}
                            >
                              Zakat
                            </MenuItem>
                            <MenuItem
                              value={'general-charity'}
                              style={{ zIndex: 999999999 }}
                            >
                              General Charity
                            </MenuItem>
                          </Select>
                        </FormControl>
                        {isShowDonationTypeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Donation type cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-xl-6'>
                        <TextField
                          label='First Name'
                          className={classes.textField}
                          value={values.firstName}
                          onChange={handleChangeFirstName}
                          required
                          // autoComplete="none"
                          name='firstName'
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <TextFieldsIcon />
                          //     </InputAdornment>
                          //   ),
                          // }}
                          inputProps={{
                            maxLength: CHARACTER_LIMIT_FIRST_NAME,
                          }}
                          variant='outlined'
                          style={{ width: '100%' }}
                        />
                        {isShowFirstNameError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              First Name cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                      <div className='col-xl-6'>
                        <TextField
                          label='Last Name'
                          className={classes.textField}
                          value={values.lastName}
                          onChange={handleChangeLastName}
                          required
                          // autoComplete="none"
                          name='lastName'
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <TextFieldsIcon />
                          //     </InputAdornment>
                          //   ),
                          // }}
                          inputProps={{
                            maxLength: CHARACTER_LIMIT_LAST_NAME,
                          }}
                          variant='outlined'
                          style={{ width: '100%' }}
                        />
                        {isShowLastNameError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Last Name cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <FormControlLabel
                          style={{ marginTop: 10 }}
                          control={
                            <Checkbox
                              checked={values.makeDonationAnonymous}
                              onChange={handleChange}
                              name='makeDonationAnonymous'
                              color='primary'
                            />
                          }
                          label='Make donation anonymous'
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <FormControl
                          variant='outlined'
                          className={classes.formControl}
                          style={{ width: '100%' }}
                        >
                          <InputLabel id='Country'>Country</InputLabel>
                          <Select
                            labelId='Country'
                            id='selectCountry'
                            required
                            autoComplete='none'
                            value={values?.country}
                            defaultValue={values?.country}
                            onChange={handleChangeCountry}
                            label='Country'
                            name='country'
                          >
                            {CountryRegionData.map((option, index) => (
                              <MenuItem key={option[0]} value={option[0]}>
                                {option[0]}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {isShowCountryError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Country cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          label='Address'
                          className={classes.textField}
                          value={values.address}
                          onChange={handleChangeAddress}
                          // autoComplete="none"
                          name='address'
                          placeholder='Address line 1'
                          required
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <Streetview />
                          //     </InputAdornment>
                          //   ),
                          //   // inputComponent: TextMaskCustom as any,
                          // }}
                          inputProps={{
                            maxLength: CHARACTER_LIMIT_EMAIL_NAME,
                          }}
                          variant='outlined'
                          style={{ width: '100%' }}
                        />
                        {isShowAddressError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Address line 1 cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          label='Address2'
                          className={classes.textField}
                          value={values.address2}
                          // autoComplete="none"
                          onChange={handleChangeAddress2}
                          name='address2'
                          placeholder='Address line 2'
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <MyLocation />
                          //     </InputAdornment>
                          //   ),
                          //   // inputComponent: TextMaskCustom as any,
                          // }}
                          inputProps={{
                            maxLength: CHARACTER_LIMIT_EMAIL_NAME,
                          }}
                          variant='outlined'
                          style={{ width: '100%' }}
                        />
                        {/* {isShowAddress2Error === true ? (
                        <div style={{ paddingTop: 5 }}>
                          <Alert severity="error">Address line 1 cannot be empty</Alert>
                        </div>
                      ) : (
                        <div></div>
                      )} */}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          label='City'
                          className={classes.textField}
                          value={values.city}
                          // autoComplete="none"
                          required
                          onChange={handleChangeCity}
                          name='city'
                          placeholder='City'
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <LocationOn />
                          //     </InputAdornment>
                          //   ),
                          //   // inputComponent: TextMaskCustom as any,
                          // }}
                          inputProps={{
                            maxLength: CHARACTER_LIMIT_EMAIL_NAME,
                          }}
                          variant='outlined'
                          style={{ width: '100%' }}
                        />
                        {isShowCityError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>City cannot be empty</Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-6'>
                        <FormControl
                          variant='outlined'
                          className={classes.formControl}
                          style={{ width: '100%' }}
                        >
                          <InputLabel id='Region'>State</InputLabel>
                          <Select
                            labelId='Region'
                            id='selectRegion'
                            value={values?.region}
                            // autoComplete="none"
                            required
                            onChange={handleChangeRegion}
                            label='Region'
                            name='Region'
                          >
                            {getRegions().map((option, index) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {isShowRegionError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              State cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                      <div className='col-xl-6'>
                        <TextField
                          label='ZIP Code'
                          className={classes.textField}
                          value={values.postalCode}
                          // autoComplete="none"
                          required
                          onChange={handleChangePostalCode}
                          name='postalCode'
                          placeholder='ZIP code.'
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <EditLocationIcon />
                          //     </InputAdornment>
                          //   ),
                          //   // inputComponent: TextMaskCustom as any,
                          // }}
                          inputProps={{
                            maxLength: CHARACTER_LIMIT_ZIP,
                          }}
                          variant='outlined'
                          style={{ width: '100%' }}
                        />
                        {isShowPostalCodeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              ZIP / postal code cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          label='Your Email'
                          className={classes.textField}
                          value={values.email}
                          // autoComplete="none"
                          onChange={handleChangeEmail}
                          name='email'
                          required
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <AlternateEmailIcon />
                          //     </InputAdornment>
                          //   ),
                          //   // inputComponent: TextMaskCustom as any,
                          // }}
                          inputProps={{
                            maxLength: CHARACTER_LIMIT_EMAIL_NAME,
                          }}
                          variant='outlined'
                          style={{ width: '100%' }}
                        />
                        {isShowEmailError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Email cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          label='Credit or Debit Card Number'
                          className={classes.textField}
                          value={values.cardNumber}
                          onChange={handleChangeCardNumber}
                          name='cardNumber'
                          type='text'
                          autoComplete='none'
                          // autoComplete="new-password"
                          required
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position='start'>
                                <PaymentIcon />
                              </InputAdornment>
                            ),
                            inputComponent: CardNumberFormatCustom as any,
                          }}
                          inputProps={{
                            maxLength: CHARACTER_LIMIT_CARD_NUMBER,
                            // autoComplete: 'off',
                            // form: {
                            //   autocomplete: 'off',
                            // },
                          }}
                          variant='outlined'
                          style={{ width: '100%' }}
                        />
                        {isShowCardNumberError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Card Number cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-6'>
                        <FormControl
                          variant='outlined'
                          className={classes.formControl}
                          style={{ width: '100%' }}
                        >
                          <InputLabel id='demo-simple-select-outlined-label'>
                            Expiration Month
                          </InputLabel>
                          <Select
                            labelId='demo-simple-select-outlined-label'
                            id='demo-simple-select-outlined'
                            required
                            autoComplete='none'
                            value={values.expirationMonth}
                            onChange={handleChangeExpirationMonth}
                            label='Expiration Month'
                            name='expirationMonth'
                          >
                            <MenuItem value=''>
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value={'01'}>01 - January</MenuItem>
                            <MenuItem value={'02'}>02 - February</MenuItem>
                            <MenuItem value={'03'}>03 - March</MenuItem>
                            <MenuItem value={'04'}>04 - April</MenuItem>
                            <MenuItem value={'05'}>05 - May</MenuItem>
                            <MenuItem value={'06'}>06 - June</MenuItem>
                            <MenuItem value={'07'}>07 - July</MenuItem>
                            <MenuItem value={'08'}>08 - August</MenuItem>
                            <MenuItem value={'9'}>09 - September</MenuItem>
                            <MenuItem value={'10'}>10 - October</MenuItem>
                            <MenuItem value={'11'}>11 - November</MenuItem>
                            <MenuItem value={'12'}>12 - December</MenuItem>
                          </Select>
                        </FormControl>
                        {isShowExpirationMonthError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Expiration Month cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                      <div className='col-xl-6'>
                        <FormControl
                          variant='outlined'
                          className={classes.formControl}
                          style={{ width: '100%' }}
                        >
                          <InputLabel id='demo-simple-select-outlined-label'>
                            Expiration Year
                          </InputLabel>
                          <Select
                            labelId='demo-simple-select-outlined-label'
                            id='demo-simple-select-outlined'
                            required
                            autoComplete='none'
                            value={values.expirationYear}
                            onChange={handleChangeExpirationYear}
                            label='Expiration Year'
                            name='expirationYear'
                          >
                            <MenuItem value=''>
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value={'2021'}>2021</MenuItem>
                            <MenuItem value={'2022'}>2022</MenuItem>
                            <MenuItem value={'2023'}>2023</MenuItem>
                            <MenuItem value={'2024'}>2024</MenuItem>
                            <MenuItem value={'2025'}>2025</MenuItem>
                            <MenuItem value={'2026'}>2026</MenuItem>
                            <MenuItem value={'2027'}>2027</MenuItem>
                            <MenuItem value={'2028'}>2028</MenuItem>
                            <MenuItem value={'2029'}>2029</MenuItem>
                            <MenuItem value={'2030'}>2030</MenuItem>
                            <MenuItem value={'2031'}>2031</MenuItem>
                            <MenuItem value={'2032'}>2032</MenuItem>
                            <MenuItem value={'2033'}>2033</MenuItem>
                            <MenuItem value={'2034'}>2034</MenuItem>
                            <MenuItem value={'2035'}>2035</MenuItem>
                            <MenuItem value={'2036'}>2036</MenuItem>
                            <MenuItem value={'2037'}>2037</MenuItem>
                            <MenuItem value={'2038'}>2038</MenuItem>
                            <MenuItem value={'2039'}>2039</MenuItem>
                            <MenuItem value={'2040'}>2040</MenuItem>
                          </Select>
                        </FormControl>
                        {isShowExpirationYearError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Expiration Year cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-6'>
                        <TextField
                          label='Security Code Number'
                          className={classes.textField}
                          value={values.securityCode}
                          onChange={handleChangeSecurityCode}
                          name='securityCode'
                          type='text'
                          // autoComplete="none"
                          // autoComplete="new-password"
                          // autoComplete="off"
                          autoComplete='none'
                          required
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position='start'>
                                <SecurityIcon />
                              </InputAdornment>
                            ),
                            inputComponent: SecurityCodeFormatCustom as any,
                          }}
                          inputProps={{
                            maxLength: CHARACTER_LIMIT_CARD_NUMBER,
                            // autoComplete: 'off',
                            // form: {
                            //   autocomplete: 'off',
                            // },
                          }}
                          variant='outlined'
                          style={{ width: '100%' }}
                        />
                        {isShowSecurityCodeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Security Code Number cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                      <div className='col-xl-6'>
                        <span className='donationsprite donatesprite-creditcards'></span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TextField
                          id='outlined-multiline-static'
                          style={{ width: '100%', marginTop: 10 }}
                          label='Comment'
                          value={values.comment}
                          onChange={handleChangeComment}
                          autoComplete='none'
                          name='comment'
                          multiline
                          rows={4}
                          variant='outlined'
                          inputProps={{
                            maxLength: CHARACTER_LIMIT_COMMENT,
                          }}
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <FormControlLabel
                          style={{ marginTop: 10 }}
                          control={
                            <Checkbox
                              checked={values.isProcessingFeeAdded}
                              onChange={handleIsProcessingFeeAddedChange}
                              name='isProcessingFeeAdded'
                              color='primary'
                            />
                          }
                          label='I’d like to cover the fees associated with my donation so more of my donation goes directly to needy'
                        />
                        <input
                          type='text'
                          autoComplete='on'
                          value=''
                          style={{
                            display: 'none',
                            opacity: 0,
                            position: 'absolute',
                            left: '-100000px',
                          }}
                          readOnly={true}
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xl-12'>
                        {isShowProgramTypeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Program Type cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowTypeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Donation cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowDonationError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Donation cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowTypeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>Type cannot be empty</Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowDonationTypeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Donation type cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowFirstNameError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              First Name cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowLastNameError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Last Name cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowCountryError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Country cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowAddressError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Address line 1 cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowCityError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>City cannot be empty</Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowRegionError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              State cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowPostalCodeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              ZIP / postal code cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowEmailError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Email cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowCardNumberError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Card Number cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowExpirationMonthError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Expiration Month cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowExpirationYearError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Expiration Year cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {isShowSecurityCodeError === true ? (
                          <div style={{ paddingTop: 5 }}>
                            <Alert severity='error'>
                              Security Code Number cannot be empty
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {showLoader === true ? (
                          <div>
                            <Alert style={{ marginTop: 20 }} severity='info'>
                              <b>
                                please wait for a while you donation transaction
                                is under progress
                              </b>
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {showMessageSuccess === true ? (
                          <div>
                            <Alert style={{ marginTop: 20 }} severity='success'>
                              <b>
                                {' '}
                                Thank you so much for your generous donation,
                                detailed receipt has been emailed to you . you
                                will receive email shortly
                              </b>
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {showMessageError === true ? (
                          <div>
                            <Alert style={{ marginTop: 20 }} severity='error'>
                              <b>{messageError}</b>
                            </Alert>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <button
                          type='submit'
                          disabled={btnDisabled}
                          className='theme-btn btn-style-one btn-donate-now-title'
                          style={{ width: '100%', marginTop: 20, height: 50 }}
                          onClick={() => {
                            if (
                              (values.donation === undefined ||
                                values.donation === null ||
                                values.donation === '') &&
                              values.selectedDonation === 'Other'
                            ) {
                              setIsShowDonationError(true);
                              setIsDonationFocus(true);
                            }
                            if (
                              values.type === undefined ||
                              values.type === null ||
                              values.type === ''
                            ) {
                              setIsShowTypeError(true);
                            }
                            if (
                              values.selectedDonation === undefined ||
                              values.selectedDonation === null ||
                              values.selectedDonation === ''
                            ) {
                              setIsShowTypeError(true);
                            }
                            if (
                              values.firstName === undefined ||
                              values.firstName === null ||
                              values.firstName === ''
                            ) {
                              setIsShowFirstNameError(true);
                            }
                            if (
                              values.lastName === undefined ||
                              values.lastName === null ||
                              values.lastName === ''
                            ) {
                              setIsShowLastNameError(true);
                            }
                            if (
                              values.country === undefined ||
                              values.country === null ||
                              values.country === ''
                            ) {
                              setIsShowCountryError(true);
                            }
                            if (
                              values.city === undefined ||
                              values.city === null ||
                              values.city === ''
                            ) {
                              setIsShowCityError(true);
                            }
                            if (
                              values.address === undefined ||
                              values.address === null ||
                              values.address === ''
                            ) {
                              setIsShowAddressError(true);
                            }
                            if (
                              values.postalCode === undefined ||
                              values.postalCode === null ||
                              values.postalCode === ''
                            ) {
                              setIsShowPostalCodeError(true);
                            }
                            if (
                              values.region === undefined ||
                              values.region === null ||
                              values.region === ''
                            ) {
                              setIsShowRegionError(true);
                            }
                            if (
                              values.email === undefined ||
                              values.email === null ||
                              values.email === ''
                            ) {
                              setIsShowEmailError(true);
                            }
                            if (
                              values.cardNumber === undefined ||
                              values.cardNumber === null ||
                              values.cardNumber === ''
                            ) {
                              setIsShowCardNumberError(true);
                            }
                            if (
                              values.expirationMonth === undefined ||
                              values.expirationMonth === null ||
                              values.expirationMonth === ''
                            ) {
                              setIsShowExpirationMonthError(true);
                            }
                            if (
                              values.programType === undefined ||
                              values.programType === null ||
                              values.programType === ''
                            ) {
                              setIsShowProgramTypeError(true);
                            }
                            if (
                              values.donationType === undefined ||
                              values.donationType === null ||
                              values.donationType === ''
                            ) {
                              setIsShowDonationTypeError(true);
                            }
                            if (
                              values.expirationYear === undefined ||
                              values.expirationYear === null ||
                              values.expirationYear === ''
                            ) {
                              setIsShowExpirationYearError(true);
                            }
                            if (
                              values.securityCode === undefined ||
                              values.securityCode === null ||
                              values.securityCode === ''
                            ) {
                              setIsShowSecurityCodeError(true);
                            }
                            if (
                              (values.donation !== undefined &&
                                values.donation !== null &&
                                values.donation !== '' &&
                                values.selectedDonation === 'Other' &&
                                values.type !== undefined &&
                                values.type !== null &&
                                values.type !== '' &&
                                values.programType !== undefined &&
                                values.programType !== null &&
                                values.programType !== '' &&
                                values.donationType !== undefined &&
                                values.donationType !== null &&
                                values.donationType !== '' &&
                                values.firstName !== undefined &&
                                values.firstName !== null &&
                                values.firstName !== '' &&
                                values.lastName !== undefined &&
                                values.lastName !== null &&
                                values.lastName !== '' &&
                                values.country !== undefined &&
                                values.country !== null &&
                                values.country !== '' &&
                                values.city !== undefined &&
                                values.city !== null &&
                                values.city !== '' &&
                                values.address !== undefined &&
                                values.address !== null &&
                                values.address !== '' &&
                                values.postalCode !== undefined &&
                                values.postalCode !== null &&
                                values.postalCode !== '' &&
                                values.region !== undefined &&
                                values.region !== null &&
                                values.region !== '' &&
                                values.email !== undefined &&
                                values.email !== null &&
                                values.email !== '' &&
                                values.cardNumber !== undefined &&
                                values.cardNumber !== null &&
                                values.cardNumber !== '' &&
                                values.expirationMonth !== undefined &&
                                values.expirationMonth !== null &&
                                values.expirationMonth !== '' &&
                                values.expirationYear !== undefined &&
                                values.expirationYear !== null &&
                                values.expirationYear !== '' &&
                                values.securityCode !== undefined &&
                                values.securityCode !== null &&
                                values.securityCode !== '') ||
                              (values.selectedDonation !== 'Other' &&
                                values.selectedDonation !== undefined &&
                                values.selectedDonation !== null &&
                                values.selectedDonation !== '' &&
                                values.type !== undefined &&
                                values.type !== null &&
                                values.type !== '' &&
                                values.programType !== undefined &&
                                values.programType !== null &&
                                values.programType !== '' &&
                                values.donationType !== undefined &&
                                values.donationType !== null &&
                                values.donationType !== '' &&
                                values.firstName !== undefined &&
                                values.firstName !== null &&
                                values.firstName !== '' &&
                                values.lastName !== undefined &&
                                values.lastName !== null &&
                                values.lastName !== '' &&
                                values.country !== undefined &&
                                values.country !== null &&
                                values.country !== '' &&
                                values.city !== undefined &&
                                values.city !== null &&
                                values.city !== '' &&
                                values.address !== undefined &&
                                values.address !== null &&
                                values.address !== '' &&
                                values.postalCode !== undefined &&
                                values.postalCode !== null &&
                                values.postalCode !== '' &&
                                values.region !== undefined &&
                                values.region !== null &&
                                values.region !== '' &&
                                values.email !== undefined &&
                                values.email !== null &&
                                values.email !== '' &&
                                values.cardNumber !== undefined &&
                                values.cardNumber !== null &&
                                values.cardNumber !== '' &&
                                values.expirationMonth !== undefined &&
                                values.expirationMonth !== null &&
                                values.expirationMonth !== '' &&
                                values.expirationYear !== undefined &&
                                values.expirationYear !== null &&
                                values.expirationYear !== '' &&
                                values.securityCode !== undefined &&
                                values.securityCode !== null &&
                                values.securityCode !== '')
                            ) {
                              setBtnDisabled(true);
                              setShowMessageSuccess(false);
                              setShowMessageError(false);
                              setShowLoader(true);
                              donateNow();
                            }
                          }}
                        >
                          Donate Now (${invoiceAmount})
                        </button>
                        <br /> <br />
                        <p>
                          *Note: Your card information is secured using SSL
                          (Secure Sockets Layer), the leading security protocol
                          on the Internet. Information is encrypted and
                          exchanged with an https server.
                        </p>
                        <p>
                          {/* 100% of donations given to sadqajariya will go to the needy. There is no administrative fee.  */}
                          We are zakat eligible and any sadaqa is welcome. We
                          are a 501c3 non-profit organization and all donations
                          are tax deductible. We will maintain a complete
                          account record certified by a CPA on our website that
                          will be accessible to our registered members.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* </form> */}
                </div>
              </div>
              <div className='sidebar-side col-lg-4 col-md-12 col-sm-12'>
                <aside className='sidebar'>
                  {/* <div className="sidebar-widget search-box">
                        	<h3 className="sidebar-title">Search</h3>
                            <form method="post" action="#">
                                <div className="form-group">
                                    <input type="search" name="search-field" value="" placeholder="Search..." required />
                                    <button type="submit"><span className="icon flaticon-search-1"></span></button>
                                </div>
                            </form>
                        </div> */}

                  <div className='sidebar-widget categories'>
                    <h3 className='sidebar-title'>About Our Programs</h3>
                    <div className='text'>
                      Righteousness starts with Kindness and Goodwill.
                    </div>
                    <div className='widget-content'>
                      <ul>
                        <li>
                          <a href='/free-grocery-for-widows-and-senior-citizen'>
                            Free Grocery for Widows and Senior Citizen
                          </a>
                        </li>
                        <li>
                          <a href='/apna-rozgar'>
                            Apna Rozgar (Small Business Setups)
                          </a>
                        </li>
                        <li>
                          <a href='/medical-support'>Free Medical Support</a>
                        </li>
                        <li>
                          <a href='/basic-schools'>
                            Free Education for Child (Basic Schools)
                          </a>
                        </li>
                        <li>
                          <a href='/water-hand-pumps'>
                            Clean Water Program (Water Hand Pumps)
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* <div className="sidebar-widget popular-posts">
                            <h3 className="sidebar-title">Latest News</h3>
                            <div className="widget-content">
                                <div className="news-post">
                                    <div className="post-thumb"><a href="blog-single.html"><img className="lazy-image" src="images/resource/image-spacer-for-validation.png" data-src="images/resource/post-thumb-6.jpg" alt=""/></a></div>
                                    <div className="date"><span className="fa fa-calendar-alt"></span> Sep 25, 2019</div>
                                    <h4><a href="blog-single.html">Consequntur magni dolore eos qui. </a></h4>
                                </div>
                                <div className="news-post">
                                    <div className="post-thumb"><a href="blog-single.html"><img className="lazy-image" src="images/resource/image-spacer-for-validation.png" data-src="images/resource/post-thumb-7.jpg" alt=""/></a></div>
                                    <div className="date"><span className="fa fa-calendar-alt"></span> Sep 20, 2019</div>
                                    <h4><a href="blog-single.html">Magni dolore eos qui ratione seque.</a></h4>
                                </div>
                                <div className="news-post">
                                    <div className="post-thumb"><a href="blog-single.html"><img className="lazy-image" src="images/resource/image-spacer-for-validation.png" data-src="images/resource/post-thumb-8.jpg" alt=""/></a></div>
                                    <div className="date"><span className="fa fa-calendar-alt"></span> Sep 14, 2019</div>
                                    <h4><a href="blog-single.html">Ratone magni dolore eos qui ratione.</a></h4>
                                </div>
                            </div>
                        </div>
                        <div className="sidebar-widget popular-tags">
                            <h3 className="sidebar-title">Popular Tags</h3>
                            <div className="widget-content">
                            	<ul className="clearfix">
                                    <li><a href="#">Education</a></li>
                                    <li><a href="#">Olympiad</a></li>
                                    <li><a href="#">Children</a></li>
                                    <li><a href="#">Animals</a></li>
                                    <li><a href="#">Donations</a></li>
                                    <li><a href="#">Causes</a></li>
                                    <li><a href="#">Drawing</a></li>
                                    <li><a href="#">Art</a></li>
                                </ul>
                            </div>
                        </div>  */}
                </aside>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Donate;
